import React from 'react';
import PropTypes from 'prop-types';
import {MenuItem, Stack, TextField} from '@mui/material';

const CategoryPicker = ({categories, value, onChange, disabled}) => {
    const parents = categories.filter(category => !category.parentId);
    const chosen = categories.find(category => category.id === value);
    const parentId = chosen ? (chosen.parentId ?? chosen.id) : '';
    const children = categories.filter(category => category.parentId === parentId);

    const handleParentChange = (event) => {
        onChange(Number(event.target.value));
    };

    const handleChildChange = (event) => {
        const next = event.target.value;
        onChange(next === '' ? parentId : Number(next));
    };

    return (
        <Stack direction={{xs: 'column', sm: 'row'}} gap={2}>
            <TextField
                select
                fullWidth
                required
                size="small"
                label="Category"
                disabled={disabled}
                data-testid="template-category"
                value={parentId === '' ? '' : String(parentId)}
                onChange={handleParentChange}
            >
                {parents.map(category => (
                    <MenuItem key={category.id} value={String(category.id)}>{category.name}</MenuItem>
                ))}
            </TextField>
            <TextField
                select
                fullWidth
                size="small"
                label="Subcategory"
                disabled={disabled || children.length === 0}
                data-testid="template-subcategory"
                value={chosen && chosen.parentId ? String(chosen.id) : ''}
                onChange={handleChildChange}
            >
                <MenuItem value="">None</MenuItem>
                {children.map(category => (
                    <MenuItem key={category.id} value={String(category.id)}>{category.name}</MenuItem>
                ))}
            </TextField>
        </Stack>
    );
};

CategoryPicker.propTypes = {
    categories: PropTypes.array.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default CategoryPicker;
